import React, { PureComponent, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Slider from 'react-slick';
import { Player } from 'ThreeTerminal_pc/video';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from './footer';

const navData = {
    nav: [
        { title: '凤凰新媒体介绍', url: '//www.ifeng.com/corp/about/intro/' },
        { title: '投资者关系 Investor Relations', url: '//ir.ifeng.com/' },
        { title: '广告服务', url: '//biz.ifeng.com/' },
        { title: '诚征英才', url: '//career.ifeng.com/' },
        { title: '保护隐私权', url: '//www.ifeng.com/corp/privacy/' },
        { title: '免责条款', url: '//www.ifeng.com/corp/exemption/' },
        { title: '意见反馈', url: '//www.ifeng.com/corp/feedback/' },
        { title: '凤凰卫视介绍', url: '//phtv.ifeng.com/intro/' },
    ],
    content: {
        text0: '凤凰新媒体',
        text1: '版权所有',
        text2: 'Copyright © 2019 Phoenix New Media Limited All Rights Reserved.',
    },
};

const pickContent = (props, name) => {
    const { content } = props;
    let result = [];

    content.modules.forEach(item => {
        if (name === item.title) result = item.data.articleList;
    });

    result.forEach(item => {
        item.thumbnail = item.thumbnail || (item.thumbnails?.image && item.thumbnails?.image[0]?.url);
    });

    return result;
};

const VideoPlayer = errorBoundary(props => {
    const [videoPlay, setVideoPlay] = useState(true);
    const [menu, setMenu] = useState(0);
    const [activeVideo, setActiveVideo] = useState(0);
    const videos = pickContent(props, !menu ? '完整视频' : '精彩片段');

    const handle = type => {
        setMenu(type);
        setActiveVideo(0);
        setVideoPlay(false);
        setTimeout(() => setVideoPlay(true));
    };

    return (
        <div className={styles.videoPlay}>
            <div className={styles.player}>
                {videoPlay ? (
                    <Player
                        videoConfig={{
                            videoLargePoster: videos[activeVideo].thumbnail,
                            videoPlayUrl: videos[activeVideo].videoPlayUrl,
                            title: videos[activeVideo].title,
                        }}
                        playermsg={{
                            width: 730,
                            height: 410,
                            isAuth: 'auth',
                            autoPlay: false,
                        }}
                    />
                ) : null}
            </div>
            <div className={styles.side_menu}>
                <div className={styles.header}>
                    <div onMouseEnter={() => handle(0)} className={`${menu === 0 ? styles.active : null}`}>
                        完整视频
                    </div>
                    <div onMouseEnter={() => handle(1)} className={`${menu === 1 ? styles.active : null}`}>
                        精彩片段
                    </div>
                </div>
                <div className={styles.items}>
                    {videos.map((item, index) => {
                        return (
                            <div
                                key={index}
                                onClick={() => {
                                    setActiveVideo(index);
                                    setVideoPlay(false);
                                    setTimeout(() => setVideoPlay(true));
                                }}
                                className={`${styles.item} ${activeVideo === index ? styles.item_active : null}`}>
                                <img
                                    src={
                                        activeVideo === index
                                            ? require('./assets/play_mini_ac.png')
                                            : require('./assets/play_mini.png')
                                    }
                                    alt=""
                                />
                                <div>{item.title}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
});

const Brilliant = errorBoundary(props => {
    const slide = useRef(null);
    const slideSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };
    const videos = pickContent(props, '精彩短视频');
    const formateData = [];

    videos.slice(1, videos.length).forEach((item, index) => {
        const key = parseInt(index / 4);

        formateData[key] = formateData[key] || [];
        formateData[key].push(item);
    });

    return (
        <div className={styles.brilliant}>
            <img className={styles.title_img} src={require('./assets/blilliant.png')} />
            <div className={styles.content}>
                <div
                    className={styles.left}
                    onClick={() => {
                        window.open(videos[0].url, '_blank');
                    }}>
                    <img src={videos[0].thumbnail} alt="" />
                    <div>{videos[0].title}</div>
                    <img className={styles.icon} src={require('./assets/play.png')} alt="" />
                </div>
                <div className={styles.right}>
                    <div
                        className={styles.slide_left_btn}
                        onClick={() => {
                            slide.current.slickPrev();
                        }}>
                        <img src={require('./assets/arrow_l.png')} alt="" />
                    </div>
                    <div className={styles.slide_right_btn} onClick={() => slide.current.slickNext()}>
                        <img src={require('./assets/arrow_r.png')} alt="" />
                    </div>
                    <Slider {...slideSettings} ref={slider => (slide.current = slider)}>
                        {formateData.map((item, _index) => {
                            return (
                                <div key={_index} className={styles.slide_item}>
                                    {item.map((card, index) => {
                                        return (
                                            <div
                                                key={index}
                                                onClick={() => {
                                                    window.open(card.url, '_blank');
                                                }}
                                                className={styles.card}>
                                                <img src={card.thumbnail} alt="" />
                                                <div>{card.title}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    );
});

const People = errorBoundary(props => {
    const people = pickContent(props, '英雄人物');

    return (
        <div className={styles.people}>
            <img className={styles.title_img} src={require('./assets/people.png')} />
            <div className={styles.itemBox}>
                {people.map((item, index) => {
                    return (
                        <div
                            key={index}
                            className={styles.item}
                            onClick={() => {
                                if (item.url === 'false') return;
                                window.open(item.url, '_blank');
                            }}>
                            <img src={item.thumbnail} alt="" />
                            <div className={styles.hover}>
                                <div>{item.title}</div>
                                <div>{item.summary}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
});

const Scene = errorBoundary(props => {
    const scenes = pickContent(props, '现场花絮');
    const [index, setIndex] = useState(0);
    const data = scenes[index];

    return (
        <div className={styles.scenes}>
            <img className={styles.title_img} src={require('./assets/scene.png')} alt="" />
            <div className={styles.scenesTitle}>
                {scenes.map((item, num) => {
                    return (
                        <div
                            key={num}
                            onClick={() => setIndex(num)}
                            onMouseEnter={() => setIndex(num)}
                            className={`${styles.scene} ${num === index ? styles.active : null}`}>
                            {item.title}
                        </div>
                    );
                })}
            </div>
            <div
                className={styles.scenesBox}
                onClick={() => {
                    window.open(data.url, '_blank');
                }}>
                <img src={data.thumbnails.image[0].url} alt="" />
                <div className={styles.right}>
                    {data.thumbnails.image.slice(1).map((item, index) => {
                        return <img key={index} src={item.url} alt="" />;
                    })}
                </div>
            </div>
        </div>
    );
});

const Ad = errorBoundary(props => {
    const data = pickContent(props, '特别鸣谢');

    return (
        <div className={styles.ad}>
            <img className={styles.title_img} src={require('./assets/ad_title.png')} alt="" />
            <div
                className={styles.box}
                onClick={() => {
                    window.open(data[0].url, '_blank');
                }}>
                <div />
                <div>
                    <img src={require('./assets/ad.png')} alt="" />
                </div>
                <div />
            </div>
        </div>
    );
});

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const data = pickContent(this.props, '热门话题')[0];

        return (
            <div className={styles.layout}>
                <div className={styles.main_header}>
                    <img
                        className="logo"
                        src="http://x0.ifengimg.com/cmpp/2020/0310/6053b78b6d55866size3_w78_h50.jpg"
                    />
                    <a className={styles.gohome} href="https://www.ifeng.com/">
                        返回首页&gt;&gt;
                    </a>
                </div>
                <div className={styles.container}>
                    <div className={styles.cover} />
                    <VideoPlayer content={content} />
                    <Brilliant content={content} />
                    <People content={content} />
                    <Scene content={content} />
                    <Ad content={content} />
                    <div className={styles.bottom}>
                        <img src={require('./assets/comment.png')} alt="" />
                        <div>
                            <iframe
                                src={`http://widget.weibo.com/topics/topic_vote_base.php?uid=2615417307&border=0&footbar=1&width=821&height=369&refer=1&filter=1&language=zh_cn&version=base&dup=1&antispam=1&isOutTopicSearch=2&isshowright=1&tag=${encodeURIComponent(
                                    encodeURIComponent(data.title),
                                )}&og=${encodeURIComponent(data.url)}&app_src=C0s9q&r=1577349024256`}
                                width="821"
                                height="665"
                                frameBorder="0"
                                scrolling="no"
                                marginHeight="0"
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.nav}>
                    <Footer content={navData} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Layout);
